module.exports = __webpack_public_path__ + "static/media/r_dot_6.ab6fe37d.png";